<template>
  <div class="idm-promotion-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="../assets/idman_logo.png" class="logo-icon" alt="IDM Logo">
          <span class="logo-text">INTERNET DOWNLOAD MANAGER</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/idm" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="main-banner">
      <div class="container">
        <div class="hero-content">
          <img src="../assets/idm-preview3.png" alt="IDM 预览图" class="hero-image">
          <div class="hero-text">
            <h1>IDM 让下载速度提升高达5倍！</h1>
            <div class="lead">Internet Download Manager (IDM) 是一款下载加速器，网页视频自动抓取，大文件断点续传, 高速批量下载特定文件，提速高达5倍! 无缝接管浏览器点击，支持批量与视频下载，效率飙升!</div>
            <el-button type="primary" size="large" class="cta-btn download-speed-btn" @click="downloadIDM">
              <el-icon><Download /></el-icon>
              <span class="btn-text">立即下载 IDM</span>
              <!-- <span class="speed-indicator">
                <span class="speed-dot"></span>
                <span class="speed-dot"></span>
                <span class="speed-dot"></span>
              </span> -->
            </el-button>
            <br/>
            <div class="download-security-info">
              <img src="../assets/Windows.png" alt="Windows">
              <span>支持系统：Windows 7/8/10/11</span>
            </div>
            <div class="download-benefits-info">
              <el-icon color="#409EFF"><Lightning /></el-icon>
              <span>一键安装</span>
              <el-icon color="#E6A23C"><Star /></el-icon>
              <span>永久使用</span>
              <el-icon color="#67C23A"><Refresh /></el-icon>
              <span>持续更新</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Feature Block -->
    <div class="featureblock">
      <div class="container">
        <!-- Feature 1: Download faster -->
        <div class="row">
          <div class="col">
            <h2>下载更快更可靠</h2>
            <p>安装 Internet Download Manager (IDM) 来停止等待下载。您将真正惊讶于 IDM 下载文件的速度有多快。IDM 还会修复损坏的文件并恢复因连接丢失、网络问题、计算机关闭或意外断电而中断的下载。</p>
          </div>
          <div class="col content-img">
            <img src="../assets/idm_screenshot_6_35.png" alt="Internet Download Manager 主界面截图">
          </div>
        </div>

        <!-- Feature 2: Powerful engine -->
        <div class="row">
          <div class="col content-img">
            <div class="img2"><img src="../assets/dynamic.jpg" alt="Internet Download Manager 动态分段"></div>
          </div>
          <div class="col">
            <h2>强大的下载引擎</h2>
            <p>我们强大的下载引擎使用独特的算法以最快的方式接收互联网数据。IDM 将始终加速下载，因为它采用了创新的动态文件分段技术。与其他下载管理器和加速器不同，IDM 在下载过程中动态分段下载的文件，并且无需额外的连接和登录阶段即可重用可用连接，以实现最佳的加速性能。</p>
            <div class="img3"><img src="../assets/dynamic.jpg" alt="Internet Download Manager 动态分段"></div>
          </div>
        </div>

        <!-- Feature 3: Browser support -->
        <div class="row">
          <div class="col">
            <h2>支持所有主流浏览器</h2>
            <p>IDM 无缝集成到 Google Chrome、FireFox、Microsoft Edge、Opera、Safari、Internet Explorer、AOL、MSN、Maxthon 和所有其他流行浏览器中。我们自1999年以来一直在开发浏览器扩展，拥有当今可用的最佳工程解决方案。IDM 提供了为 Chrome、Firefox、旧版和新版 Edge、Opera 以及其他浏览器安装扩展的功能。</p>
            <p class="subtext">您需要始终保持 IDM 扩展在浏览器中安装并启用，以便从浏览器接管下载并拥有 IDM 的右键菜单项！如果您遇到任何问题，请首先检查浏览器中是否安装并启用了"IDM 集成模块"扩展。</p>
          </div>
          <div class="col content-img">
            <img src="../assets/skpscr.jpeg" alt="Internet Download Manager 浏览器支持">
          </div>
        </div>

        <!-- Feature 4: Download selected files -->
        <div class="row">
          <div class="col content-img">
            <div class="img2"><img src="../assets/idm-preview1.png" alt="使用 Internet Download Manager 下载选中的文件"></div>
          </div>
          <div class="col">
            <h2>一键下载选中的文件</h2>
            <p>当在浏览器中用鼠标选择多个链接时，IDM 将显示"使用 IDM 下载"按钮。您还可以在"选项→常规选项卡→自定义浏览器中的下载面板" IDM 对话框中最小化此按钮。</p>
            <div class="img3"><img src="../assets/idm-preview1.png" alt="使用 Internet Download Manager 下载选中的文件"></div>
          </div>
        </div>

        <!-- Feature 5: Video download -->
        <div class="row">
          <div class="col">
            <h2>从您喜爱的网站下载文件</h2>
            <p>安装"IDM 集成模块"浏览器扩展后，只需继续浏览互联网，您就会惊讶地发现使用 IDM 视频下载面板从您喜爱的网站下载任何内容是多么容易。</p>
          </div>
          <div class="col content-img">
            <img src="../assets/idm-preview2.png" alt="使用 Internet Download Manager 下载视频动画">
          </div>
        </div>

        <!-- Feature 6: Built-in Scheduler -->
        <div class="row">
          <div class="col content-img">
            <div class="img2"><img src="../assets/queue.png" alt="在 Internet Download Manager 中使用队列"></div>
          </div>
          <div class="col">
            <h2>内置调度器</h2>
            <p>Internet Download Manager 可以在设定的时间连接到互联网，下载您想要的文件，完成后断开连接或关闭计算机。您还可以使用定期同步文件来同步更改。可以创建和调度多个下载队列用于下载或同步。</p>
            <div class="img3"><img src="../assets/queue.png" alt="在 Internet Download Manager 中使用队列"></div>
          </div>
        </div>

        <!-- Feature 7: Download categories -->
        <div class="row">
          <div class="col">
            <h2>下载分类</h2>
            <p>Internet Download Manager 可用于使用定义的下载类别自动组织下载。您可以为某些文件类型或特定站点添加自定义类别。</p>
          </div>
          <div class="col content-img"><img src="../assets/categories.gif" alt="Internet Download Manager 下载分类"></div>
        </div>

        <!-- Feature 8: Customizable Interface -->
        <div class="row">
          <div class="col content-img">
            <div class="img2"><img src="../assets/idm_custom.gif" alt="Internet Download Manager 界面定制"></div>
          </div>
          <div class="col">
            <h2>可定制的界面</h2>
            <p>您可以选择主 IDM 窗口中显示的顺序、按钮和列。工具栏有几种不同的皮肤，具有不同的按钮样式。所有皮肤都可以从 IDM 主页下载。用户也可以设计自己的皮肤。您还可以选择浅色或深色 IDM 主题。</p>
            <div class="img3"><img src="../assets/idm_custom.gif" alt="Internet Download Manager 界面定制"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户评价版块 -->
    <div class="reviews-section">
      <div class="container">
        <h2>用户评价</h2>
        <p class="section-subtitle">来自全球用户的真实好评</p>
        <div class="reviews-grid">
          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">👨‍💼</div>
                <div class="reviewer-name">张先生</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"IDM 确实快！从前下载 1GB 文件需要 30 分钟，现在只要 6 分钟。强烈推荐！"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">👩‍🔬</div>
                <div class="reviewer-name">李女士</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"浏览器视频自动检测功能太方便了，一键下载喜欢的视频，不用手动复制链接。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">🧑‍💻</div>
                <div class="reviewer-name">王工程师</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"支持断点续传，网络掉线也不怕。下载大文件非常稳定，已推荐给全部同事。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">📚</div>
                <div class="reviewer-name">陈老师</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"用了 3 年 IDM，从未让我失望。每天下载课程资料都靠它。值得投资！"</p>
          </div>
        </div>
        <div class="review-stats">
          <div class="stat-item">
            <div class="stat-number">500万+</div>
            <div class="stat-label">全球用户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">4.8★</div>
            <div class="stat-label">平均评分</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">98%</div>
            <div class="stat-label">推荐率</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中间 CTA 按钮区域 -->
    <div class="middle-cta-section">
      <div class="container">
        <h2>立即体验极速下载</h2>
        <p>加入 500 万全球用户的行列，享受 5 倍速度提升</p>
        <div class="cta-buttons">
          <el-button type="primary" size="large" class="cta-btn" @click="downloadIDM">
            <el-icon><Download /></el-icon>
            立即免费下载
          </el-button>
          <el-button type="default" size="large" class="cta-btn-secondary" @click="scrollToFeatures">
            了解更多功能
          </el-button>
        </div>
      </div>
    </div>

    <!-- Awards Section -->
    <div class="awardsblock">
      <div class="container">
        <h2>Internet Download Manager 奖项</h2>
        <div class="awards main_page">
          <div class="award">
            <div class="awardimg"><img src="../assets/IDM_12_cnet_top_rated.gif" alt="CNet 顶级评分 Internet Download Manager 奖项"></div>
            <p class="subtext">CNet<br>顶级评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/softpedia_m.gif" alt="Softpedia Internet Download Manager 奖项"></div>
            <p class="subtext">Softpedia<br>5/5 评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/IDM_12_awardcnets.gif" alt="CNet 评分 最受欢迎 Internet Download Manager 奖项"></div>
            <p class="subtext">CNet 评分<br>最受欢迎</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/volftps.gif" alt="GoldSoft Internet Download Manager 奖项"></div>
            <p class="subtext">GoldSoft.com<br>5/5 评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/IDM_12_zdnetpicks.gif" alt="ZDNet 编辑推荐 Internet Download Manager 奖项"></div>
            <p class="subtext">ZDNet<br>编辑推荐</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/award2.gif" alt="Freetrialsoft Internet Download Manager 奖项"></div>
            <p class="subtext">Freetrialsoft<br>5/5 评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/IDM_12_cnetpicks.gif" alt="Download.com 编辑推荐 Internet Download Manager 奖项"></div>
            <p class="subtext">Download.com<br>编辑推荐</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/IDM_12_softpile_m.gif" alt="Softpile Internet Download Manager 奖项"></div>
            <p class="subtext">Softpile.com<br>5/5 评分</p>
          </div>
        </div>
      </div>
    </div>

        <!-- Try Free Section -->
    <div class="earnmoney tryforfreeblock">
      <div class="container">
        <h2>立即下载 Internet Download Manager</h2>
        <p>下载效率翻倍！IDM 提速 5 倍 + 无缝接管浏览器，批量 / 视频下载全支持下载并安装 IDM，立即下载不等待！</p>
        <el-button type="primary" size="large" class="cta-btn" @click="downloadIDM">
          <el-icon><Download /></el-icon>
          立即下载 IDM
        </el-button>
        <br><br>
        <div class="subtext">
          <img src="../assets/os.png" alt="Internet Download Manager 系统支持"><br>
          支持系统：Windows 7, Windows 8/8.1, Windows 10, Windows 11
        </div>
      </div>
    </div>
    
    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <div class="qrcode-container">
            <img src="../assets/wechat.png" alt="企业微信二维码" class="qrcode-img">
          </div>
          <div class="service-info">
            <p>企业微信</p>
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击添加客服
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <div class="footer-main">
          <p class="copyright">Copyright©2025 奇安科技有限公司贵州分公司黔ICP备2026000902号</p>
          <div class="footer-links">
            <a href="/#/idm" class="footer-link">隐私政策</a>
            <span class="separator">|</span>
            <a href="/#/idm" class="footer-link">用户协议</a>
            <span class="separator">|</span>
            <a href="/#/about" class="footer-link">联系我们</a>
          </div>
        </div>
        <div class="footer-disclaimer">
          <p><strong>免责声明：</strong>本网站的图文和软件资源来源于网络。若任何内容侵犯您的合法权益，请立即<a href="mailto:softdown51@outlook.com" class="disclaimer-link">与我们联系</a>，我们会在 24 小时内核实并删除。</p>
          <p class="legal-note">本站所有软件信息仅供参考，用户需自行承担使用风险。任何因使用本站资源产生的问题，本站概不负责。</p>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Download,
  Service
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/idm') {
    return '/idm'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/idm') {
    router.push('/idm')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}


// 滚动到功能区域
const scrollToFeatures = () => {
  const featureBlock = document.querySelector('.featureblock')
  if (featureBlock) {
    featureBlock.scrollIntoView({ behavior: 'smooth' })
  }
}

// 下载IDM
const downloadIDM = () => {
  // 发送Umami自定义事件 - IDM下载
  if (window.umami) {
    window.umami.track('download-idm', {
      type: 'software',
      name: 'IDM',
      version: 'latest',
      url: 'https://file.51softdown.cn/download/idm/IDM_v6.42.0.exe'
    });
  }
  
  // 实际的下载逻辑
  window.open('https://file.51softdown.cn/download/idm/IDM_v6.42.0.exe', '_blank');
}



// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

// 组件挂载时开始轮播
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  // 不再需要自动轮播
  
  // 设置页面标题和 favicon
  document.title = 'IDM 下载器-官方正版'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/idm.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/idm.ico'
    document.head.appendChild(favicon)
  }
})

onUnmounted(() => {
  // 不再需要停止轮播
})
</script>

<style scoped>
.idm-promotion-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #3F414B, #3F414B);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* Hero Section */
.main-banner {
  padding: 60px 0;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 50%, #90caf9 100%);
  color: #333;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.main-banner .container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
  padding: 40px 20px;
}

.hero-image {
  max-width: 730px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  flex: 1;
  min-width: 300px;
}

.hero-text {
  flex: 1;
  min-width: 300px;
  text-align: left;
  padding: 20px 0;
}

.main-banner h1 {
  font-size: 2.8rem;
  margin-bottom: 25px;
  font-weight: 800;
  line-height: 1.2;
}

.main-banner .lead {
  font-size: 1.3rem;
  margin-bottom: 35px;
  line-height: 1.6;
  opacity: 0.95;
}

.main-banner .cta-btn {
  background-color: #1FB393;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  padding: 25px 36px;
  margin-left: 60px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(31, 179, 147, 0.3);
}

.main-banner .cta-btn:hover {
  background-color: #179e81;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(31, 179, 147, 0.4);
}


.download-security-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 36px;
  gap: 10px;
  margin-top: 15px;
  margin-left: 0;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.download-security-info span {
  margin-right: 15px;
}

.download-security-info span:last-child {
  margin-right: 0;
}

.download-benefits-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 36px;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.download-benefits-info span {
  margin-right: 15px;
}

.download-benefits-info span:last-child {
  margin-right: 0;
}

/* 下载速度动效 */
@keyframes speedFlow {
  0% {
    opacity: 0;
    transform: translateX(-10px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(20px);
  }
}

@keyframes pulse-scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.download-speed-btn {
  position: relative;
  overflow: hidden;
}

.download-speed-btn:hover .speed-indicator {
  opacity: 1;
  visibility: visible;
}

.speed-indicator {
  display: flex;
  gap: 6px;
  margin-left: 8px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.speed-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  animation: speedFlow 1.2s ease-in-out infinite;
}

.speed-dot:nth-child(1) {
  animation-delay: 0s;
}

.speed-dot:nth-child(2) {
  animation-delay: 0.3s;
}

.speed-dot:nth-child(3) {
  animation-delay: 0.6s;
}

.btn-text {
  position: relative;
}

.download-speed-btn:active {
  animation: pulse-scale 0.4s ease;
}

/* Feature Block */
.featureblock {
  padding: 80px 0;
}

.featureblock .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.featureblock .row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 60px;
  align-items: center;
}

.featureblock .row:nth-child(even) {
  flex-direction: row-reverse;
}

.featureblock .col {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.featureblock .col.content-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.featureblock h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: 700;
}

.featureblock p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 20px;
}

.featureblock .content-img img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.featureblock .img2, .featureblock .img3 {
  display: none;
}

.featureblock .subtext {
  font-size: 0.9rem;
  color: #999;
  margin-top: 10px;
}

/* 上段按钮区域 */
.middle-cta-section {
  padding: 80px 0;
  background: linear-gradient(135deg, rgba(31, 179, 147, 0.1) 0%, rgba(24, 144, 255, 0.1) 100%);
  text-align: center;
}

.middle-cta-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.middle-cta-section h2 {
  font-size: 2rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: 700;
}

.middle-cta-section p {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.cta-btn-secondary {
  background-color: white;
  border: 2px solid #1FB393;
  color: #1FB393;
  font-weight: 600;
  padding: 16px 36px;
  border-radius: 30px;
  font-size: 16px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.cta-btn-secondary:hover {
  background-color: #f0fdf4;
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(31, 179, 147, 0.2);
}

/* 用户评价版块 */
.reviews-section {
  padding: 80px 0;
  background: white;
}

.reviews-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.reviews-section h2 {
  font-size: 2rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: 700;
  text-align: center;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  text-align: center;
  margin-bottom: 50px;
}

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.review-card {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
}

.review-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
  background: white;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewer-avatar {
  font-size: 32px;
  line-height: 1;
}

.reviewer-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.review-stars {
  color: #ffc107;
  font-size: 16px;
  letter-spacing: 2px;
}

.review-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #666;
  font-style: italic;
  margin: 0;
}

.review-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
  padding: 40px 0;
  border-top: 2px solid #f0f0f0;
  border-bottom: 2px solid #f0f0f0;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1FB393;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
}

/* Section Styles */
.section {
  padding: 80px 0;
}

.section.center {
  text-align: center;
  background: #f8f9fa;
}

.section.center .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.cta-btn {
  background-color: #1FB393;
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 15px 30px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
}

.cta-btn:hover {
  background-color: #179e81;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.cta-btn2 {
  background-color: transparent;
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 15px 30px;
  border: 2px solid #1FB393;
  color: #1FB393;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
}

.cta-btn2:hover {
  background-color: #f0fdf4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Try Free Block */
.earnmoney {
  padding: 80px 0;
  background: linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%);
  color: white;
  text-align: center;
}

.earnmoney h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.earnmoney p {
  font-size: 1.1rem;
  margin-bottom: 30px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
}

.earnmoney .subtext {
  font-size: 0.9rem;
  margin-top: 20px;
  opacity: 0.8;
}

.earnmoney .subtext img {
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.tryforfreeblock {
  background: #f8f9fa;
  color: #333;
}

/* New Version Section */
.newversion {
  padding: 80px 0;
  background: white;
}

.newversion .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.newversion .row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.newversion .col {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.newversion .img2 {
  display: none;
}

.newversion .tag {
  background: #1FB393;
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 20px;
}

.newversion p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

/* Awards Block */
.awardsblock {
  padding: 80px 0;
  background: #f8f9fa;
  text-align: center;
}

.awardsblock .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.awardsblock h2 {
  font-size: 2rem;
  margin-bottom: 40px;
  color: #333;
  font-weight: 700;
}

.awards.main_page {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
}

.award {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
}

.awardimg {
  margin-bottom: 15px;
}

.awardimg img {
  max-width: 100%;
  height: auto;
}

.award .subtext {
  font-size: 0.9rem;
  color: #666;
}

.link-btn {
  color: #1890ff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.link-btn:hover {
  color: #40a9ff;
  text-decoration: underline;
}

/* 客服联系方式 */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.service-toggle {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  padding: 12px 16px;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 24px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #1890ff;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.qrcode-container {
  text-align: center;
  margin-bottom: 15px;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #40a9ff;
}

/* Footer */
.footer {
  background: #333;
  color: #999;
  padding: 50px 0;
  text-align: center;
  max-width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  background: #333;
  max-width: 100%;
}

.footer-main {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright {
  margin-bottom: 15px;
  font-size: 13px;
  color: #999;
  letter-spacing: 0.5px;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.footer-link {
  font-size: 13px;
  color: #999;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

.footer-link:hover {
  color: #fff;
}

.separator {
  color: #555;
  font-size: 12px;
}

.footer-disclaimer {
  text-align: left;
  max-width: 900px;
  margin: 0 auto;
}

.footer-disclaimer p {
  margin: 12px 0;
  font-size: 12px;
  line-height: 1.6;
  color: #999;
}

.footer-disclaimer strong {
  color: #bbb;
  font-weight: 600;
}

.disclaimer-link {
  color: #1FB393;
  text-decoration: none;
  transition: color 0.3s ease;
}

.disclaimer-link:hover {
  color: #20c9a6;
  text-decoration: underline;
}

.legal-note {
  color: #777 !important;
  font-size: 11px !important;
  margin-top: 15px;
}

/* Responsive */
@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .main-banner h1 {
    font-size: 2rem;
  }
  
  .main-banner .lead {
    font-size: 1rem;
  }
  
  .featureblock .row {
    flex-direction: column !important;
  }
  
  .featureblock .col {
    padding: 20px 0;
  }
  
  .featureblock .col.content-img {
    order: -1;
  }
  
  .awards.main_page {
    gap: 15px;
  }
  
  .award {
    min-width: 120px;
    max-width: 150px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
